import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CargoItemTypesLogicService } from './logic/cargo-item-types/cargo-item-types-logic.service';
import { CargoItemTypesService } from './logic/cargo-item-types.service';
import { CargoItemTypesDaoService } from './dao/cargo-item-types-dao.service';
import { CargoItemTypesDbDaoService } from './dao/cargo-item-types-dao/cargo-item-types-db-dao.service';
import { CargoItemTypeDbTableDefinition } from './dao/cargo-item-types-dao/cargo-item-types-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: CargoItemTypesService, useClass: CargoItemTypesLogicService },
    { provide: CargoItemTypesDaoService, useClass: CargoItemTypesDbDaoService },
    { provide: CargoItemTypeDbTableDefinition },
  ]
})
export class CargoItemTypesModule {}
